module.exports = __webpack_public_path__ + "img/logo.05922b21.png";